export default __webpack_public_path__ + "static/media/109_mizuo_kawai_0001.84bad23a.png";